'.radio-styles'
import {pxToRem} from '../../../utills/pxToRem'

export default {
    baseStyle: {
        container: {display: 'flex'},
        label: {
            width: 'full'
        },
        control: {
            borderColor: 'black',
            background: 'none',
            backgroundColor: 'none',
            borderWidth: pxToRem(1),
            width: pxToRem(20),
            height: pxToRem(20),
            marginTop: '0.125em',

            _checked: {
                background: 'none',
                backgroundColor: 'none',
                border: `${pxToRem(1)} solid black`,

                _hover: {
                    background: 'none',
                    borderColor: 'black'
                },

                '::before': {
                    backgroundColor: 'black',
                    margin: `${pxToRem(4)} auto`,
                    height: pxToRem(12),
                    width: pxToRem(12)
                }
            },
            _indeterminate: {}
        }
    },
    sizes: {
        md: {
            container: {alignItems: 'flex-start'},
            control: {marginTop: '0.125em'},
            label: {marginLeft: 3}
        }
    },
    variants: {
        payment: {
            container: {
                fontWeight: 500,
                height: [`${pxToRem(40)}`, `${pxToRem(40)}`, `${pxToRem(50)}`],
                display: 'flex',
                alignItems: 'center',
                padding: [`${pxToRem(10)}`, `${pxToRem(10)}`, `${pxToRem(15)}`],
                bg: 'gray.75'
            },
            label: {
                marginLeft: [`${pxToRem(10)}`, `${pxToRem(10)}`, `${pxToRem(15)}`],
                maringTop: 0
            },
            control: {
                marginTop: 0
            }
        }
    }
}
